import { render, staticRenderFns } from "./UploadFileDiloag.vue?vue&type=template&id=a8fd9326&v-slot%3Amodal-body=true&"
import script from "./UploadFileDiloag.vue?vue&type=script&lang=js&"
export * from "./UploadFileDiloag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports